// ----------------------------
// Virtual Market
// ----------------------------

// ------------------------------------
// Imports
// ------------------------------------
import { put, call, takeLatest } from 'redux-saga/effects';

import {
    GET_LABELS, getLabelsAdminSucceeded, getLabelsAdminFailed,
    TOGGLE_LABEL, toggleLabelSucceeded, toggleLabelFailed,
    GET_QUESTIONNAIRES, getQuestionnairesAdminSucceeded, getQuestionnairesAdminFailed,
    TOGGLE_QUESTIONNAIRE, toggleQuestionnaireSucceeded, toggleQuestionnaireFailed,
    REFRESH_SESSION, refreshSessionSucceeded, refreshSessionFailed
} from '../modules/module_admin.js';

import {
    getTokenSucceeded, setStartHour, setEndHour
  } from '../modules/module_settings.js'

import { API_REQUEST_STATUS_SUCCEEDED, API_REQUEST_STATUS_FAILED } from 'services/config'
import { doCallback } from 'utilities/general-utils'
import protocols from 'common-protocols'

import { updateAdminSettingsStorage } from 'utilities/session-utils'

// ------------------------------------
// Services
// ------------------------------------
import { getTokenAdmin, requestLabels, requestToggleLabel, requestQuestionnaires, requestToggleQuestionnaire, requestRefreshSession } from 'services/admin-api'


// ------------------------------------
// Sagas
// ------------------------------------

/* Sagas - Workers */
function* getLabelsAdminRequested(action) {
    const {response, error} = yield call(requestLabels, action.token);
    if(response.data){
        const labels = response.data;
        yield put(getLabelsAdminSucceeded(labels));
    } else {
        yield put(getLabelsAdminFailed(error));
    }
}

function* toggleLabelRequested(action){
    const {response, error} = yield call(requestToggleLabel, {
        token: action.token,
        pkEtiqueta: action.idEtiqueta,
        activo: action.active
    });
    if(response.data){
        const changeAccepted = response.data;
        yield put(toggleLabelSucceeded({
            pkEtiqueta: action.idEtiqueta,
            changeAccepted
        }));
    } else {
        yield put(toggleLabelFailed(error));
    }
}

function* getQuestionnairesAdminRequested(action) {
    const {response, error} = yield call(requestQuestionnaires, action.token);
    if(response.data){
        const questionnaires = response.data;
        yield put(getQuestionnairesAdminSucceeded(questionnaires));
    } else {
        yield put(getQuestionnairesAdminFailed(error));
    }
}

function* toggleQuestionnaireRequested(action){
    const {response, error} = yield call(requestToggleQuestionnaire, {
        token: action.token,
        pkCuestionario: action.idCuestionario,
        activo: action.active
    });
    if(response.data){
        const changeAccepted = response.data;
        yield put(toggleQuestionnaireSucceeded({
            pkCuestionario: action.idCuestionario,
            changeAccepted
        }));
    } else {
        yield put(toggleQuestionnaireFailed(error));
    }
}

function* refreshSessionRequested({token}){
    
    const { error, response } = yield call(requestRefreshSession, token);
    const start = new Date();
    let end = new Date();
    end.setMilliseconds(3630000);

    if(response.data){
        console.log(start);
        console.log(end);
        yield put(getTokenSucceeded(response.data));
        yield put(setStartHour(start));
        yield put(setEndHour(end));
        updateAdminSettingsStorage(response.data, 'token');
        updateAdminSettingsStorage(start, 'startHour');
        updateAdminSettingsStorage(end, 'endHour');
    } else {
        yield put(refreshSessionFailed(error));
    }
}

/* Sagas - Watchers/Listeners */
export function* watchGetLabelsAdmin() {
    yield takeLatest(GET_LABELS, getLabelsAdminRequested);
}

export function* watchToggleLabel(){
    yield takeLatest(TOGGLE_LABEL, toggleLabelRequested);
}

export function* watchGetQuestionnairesAdmin() {
    yield takeLatest(GET_QUESTIONNAIRES, getQuestionnairesAdminRequested);
}

export function* watchToggleQuestionnaire(){
    yield takeLatest(TOGGLE_QUESTIONNAIRE, toggleQuestionnaireRequested);
}

export function* watchRefreshSession(){
    yield takeLatest(REFRESH_SESSION, refreshSessionRequested);
}

// ------------------------------------
// Exports Functions
// ------------------------------------

export const adminSagas = [
    watchGetLabelsAdmin,
    watchToggleLabel,
    watchGetQuestionnairesAdmin,
    watchToggleQuestionnaire,
    watchRefreshSession
];


// WEBPACK FOOTER //
// ./src/store/sagas/sagas_admin.js